/** 앱 안 이동 기록이 있으면 이전 화면으로, 딥링크 진입이면 홈으로 보낸다. */
export function goBackOrPlayground(navigate) {
  const idx = window.history.state?.idx;
  if (typeof idx === 'number' && idx > 0) {
    navigate(-1);
    return;
  }
  navigate('/playground');
}
